<!-- Hold Receipt (F4). Chrome comes from styles/components/_dialogs.scss. -->
<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="pos-dlg pos-dlg-sm premium-dialog"
  [showHeader]="false"
>
  <div class="premium-dialog-container" (keydown)="onKeyDown($event)">
    <div class="premium-header">
      <div class="premium-header-content">
        <h3 class="premium-title">Hold Receipt</h3>
        <p class="premium-subtitle">Save current order for later</p>
      </div>
      <button
        class="premium-close-btn"
        (click)="onCancel()"
        type="button"
        aria-label="Close hold receipt dialog"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="premium-body hold-body">
      <!-- Mobile Number (only shown when not already filled) -->
      <div class="hold-field" *ngIf="showMobileInput">
        <label for="holdMobileNumberNew" class="hold-label">
          Mobile Number
          <span class="required-mark" *ngIf="isMobileMandatory">*</span>
        </label>
        <input
          #holdMobileInput
          type="tel"
          id="holdMobileNumberNew"
          class="hold-input"
          [(ngModel)]="localMobileNumber"
          (keypress)="allowOnlyNumbers($event)"
          maxlength="10"
          pattern="[0-9]*"
          inputmode="numeric"
          placeholder="Enter 10-digit mobile number"
          autocomplete="off"
        />
      </div>

      <div class="hold-field">
        <label for="holdReceiptNameNew" class="hold-label">
          Customer Name <span class="required-mark">*</span>
        </label>
        <input
          #holdNameInput
          type="text"
          id="holdReceiptNameNew"
          class="hold-input"
          [(ngModel)]="localHoldReceiptName"
          placeholder="Enter customer name"
          autocomplete="off"
        />
      </div>
    </div>

    <div class="premium-footer">
      <button
        class="premium-btn premium-btn-secondary"
        (click)="onCancel()"
        type="button"
      >
        Cancel
      </button>
      <button
        class="premium-btn premium-btn-primary hold-dialog-submit-btn"
        (click)="onSubmit()"
        [disabled]="isSubmitDisabled"
        type="button"
      >
        Save Receipt
      </button>
    </div>
  </div>
</p-dialog>
